"use client";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { X } from "lucide-react";
import { useState, useEffect } from "react";
import { createClient } from "@/utils/supabase/client";
import { toast } from "@/hooks/use-toast";

export default function RandomList({
  campaign,
  openGiftBox,
  setOpenGiftBox,
  handleBack,
  openTable,
  setOpenTable,
  setDate,
}: {
  campaign: any;
  openGiftBox: boolean;
  setOpenGiftBox: (open: boolean) => void;
  handleBack: () => void;
  openTable: boolean;
  setOpenTable: (open: boolean) => void;
  setDate?: (date: number) => void;
}) {
  const [step, setStep] = useState<number>(1);
  const [participant, setParticipant] = useState<any>(null);

  const handleRandom = async () => {
    const supabase = await createClient();
    const { data, error } = await supabase.rpc("draw_random_winner_2", {
      p_campaign_id: campaign.id,
    });

    if (error) {
      toast({
        title: "Rất tiếc",
        description: error.message,
        variant: "destructive",
        style: {
          color: "white",
        },
      });
    } else {
      setParticipant(data[0]);
      setStep(2);
      setDate?.(Date.now());
    }
  };

  const [list, setList] = useState<any[]>([]);

  const getCode = async () => {
    const supabase = await createClient();
    const { data, error } = await supabase.rpc("get_longest_code_length", {
      p_campaign_id: campaign.id,
    });

    if (error) {
      toast({
        title: "Rất tiếc",
        description: "Đã có lỗi xảy ra",
        variant: "destructive",
        style: {
          color: "white",
        },
      });
    } else {
      setList(Array.from({ length: data }, (_, i) => i));
    }
  };

  useEffect(() => {
    if (openGiftBox) {
      getCode();
    } else {
      setParticipant(null);
      setStep(1);
    }
  }, [openGiftBox]);

  return (
    <Dialog open={openGiftBox} onOpenChange={setOpenGiftBox}>
      <DialogContent
        onInteractOutside={(event) => {
          event.preventDefault();
        }}
        showCloseButton={false}
        className="bg-white p-0 overflow-hidden border-none rounded-2xl lg:max-w-[1400px] w-[calc(100vw-20px)] sm:max-w-[calc(100vw-20px)]"
      >
        <VisuallyHidden>
          <DialogTitle>Hidden Title</DialogTitle>
        </VisuallyHidden>
        <div
          style={{
            backgroundImage: `url(${
              campaign?.game?.gift_box_background?.url || ""
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className={`h-[calc(100vh-40px)] max-h-[100vh] text-center editor-wrapper pop-up-content popup-gift-box-content text-white lg:px-16 py-16 px-4 flex flex-col gap-12 ${step === 2 ? "justify-center" : "justify-between"}`}
        >
          <div
            onClick={() => setOpenGiftBox(false)}
            className="cursor-pointer flex items-center justify-center bg-white rounded-full w-7 h-7 absolute top-4 right-4"
          >
            <X className="w-4 h-4 text-gray-500" />
          </div>
          {
            step === 1 ? (
              <div dangerouslySetInnerHTML={{ __html: campaign?.game?.gift_box_content }} />
            ) : (
              <img 
                className="w-[180px] h-[180px] mx-auto object-cover"
                src={participant?.prize?.image?.url || ""} 
                alt="" 
              />
            )
          }
          <div className="flex flex-wrap gap-4 justify-center max-w-[100vh] mx-auto">
            {(participant ? participant[campaign.verify.apply_allocation[0]].split('') : list).map((item: any, index: number) => (
              <div
                key={index}
                className="w-[110px] h-[110px] rounded-xl bg-white flex items-center justify-center text-black font-bold text-3xl"
              >
                {participant ? item : null}
              </div>
            ))}
          </div>
          <div>
            {step === 1 && (
              <div className="flex flex-col gap-4 items-center">
                <img 
                  onClick={handleRandom}
                  src={campaign?.game?.gift_button?.[0]?.url || ""}
                  alt="button" 
                  className="cursor-pointer"
                />
                <img 
                  onClick={() => setOpenTable(true)}
                  src={campaign?.game?.gift_button?.[1]?.url || ""}
                  alt="button" 
                  className="cursor-pointer"
                />
              </div>
            )}
            {step === 2 && (
              <div className="flex flex-col gap-10 items-center">
                <div dangerouslySetInnerHTML={{ __html: participant?.prize?.description }} />
                <img 
                  onClick={handleBack}
                  src={campaign?.game?.gift_button?.[2]?.url || ""}
                  alt="button" 
                  className="cursor-pointer"
                />
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
